import FilterButton from "@/views/MentionsView/FilterButton";
import DateRangeButton from "@/views/MentionsView/partials/DateRangeButton";
import { ALL_MENTION_VIEW_DATE_RANGES } from "./ranges";
import { Button } from "@components/ui/button";
import { Separator } from "@components/ui/separator";
import { SidebarTrigger } from "@components/ui/sidebar";
import { i18n } from "@lingui/core";
import { Trans, useLingui } from "@lingui/react/macro";
import { DownloadIcon, SendIcon } from "lucide-react";
import { Feature } from "@components/Feature";
import { FEATURE } from "@/features";

export default function Header({
  isFavoritePage,
  tagTitle,
  onExport,
  onShare,
}: {
  isFavoritePage: boolean;
  tagTitle?: string;
  onExport: () => void;
  onShare: () => void;
}) {
  const { t } = useLingui();

  // Helpers
  const title = isFavoritePage ? t`Sparade omnämnanden` : tagTitle;

  // Translate range labels at render time to ensure proper i18n
  const ranges = ALL_MENTION_VIEW_DATE_RANGES.map(({ label, ...rest }) => ({
    label: i18n._(label),
    ...rest,
  }));

  return (
    <>
      <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
        <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6 max-w-7xl">
          <SidebarTrigger className="-ml-1" />
          <Separator
            orientation="vertical"
            className="mx-2 data-[orientation=vertical]:h-4"
          />
          <p>{title}</p>

          <Button
            type="button"
            className="ml-auto"
            variant="outline"
            onClick={onShare}
          >
            <SendIcon />
            <span className="sr-only">
              <Trans>Dela</Trans>
            </span>
          </Button>

          <Feature required={FEATURE.HAS_EXCEL_EXPORT_FEATURE}>
            <Button
              type="button"
              variant="outline"
              onClick={onExport}
              data-testid="open-export-modal"
            >
              <Trans>Exportera</Trans>
              <DownloadIcon />
            </Button>
          </Feature>
        </div>
      </header>

      <div className="border-b">
        <div className="w-full p-4 lg:p-6 max-w-7xl flex justify-between">
          <h1 className="text-2xl font-bold">{title}</h1>

          <div className="flex items-center gap-2.5">
            <DateRangeButton ranges={ranges} />
            {!isFavoritePage && <FilterButton />}
          </div>
        </div>
      </div>
    </>
  );
}
